<template>
  <div>
    <FormItem
      label="和其他实验："
      prop="experimentType"
      :rules="[
        {
          required: true,
          message: '请选择和其他实验的关系',
          trigger: 'change'
        }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <RadioGroup
          v-model="formData.experimentType"
          type="button"
          button-style="solid"
        >
          <Radio label="0" :disabled="readonly">互斥</Radio>
          <Radio label="1" :disabled="readonly">并行</Radio>
        </RadioGroup>
      </Tooltip>
    </FormItem>

    <FormItem
      label="操作系统："
      prop="deviceSys"
      :rules="[
        { required: true, message: '请选择操作系统', trigger: 'change' }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <RadioGroup
          v-model="formData.deviceSys"
          type="button"
          button-style="solid"
        >
          <Radio label="-1" :disabled="readonly">不限</Radio>
          <Radio label="0" :disabled="readonly">IOS</Radio>
          <Radio label="1" :disabled="readonly">安卓</Radio>
        </RadioGroup>
      </Tooltip>
    </FormItem>

    <FormItem
      label="推广渠道："
      prop="linkChannel"
      :rules="[
        {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            callback()
          }
        }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <div style="display: flex">
          <Checkbox
            border
            :value="!formData.linkChannel || !formData.linkChannel.length"
            :disabled="readonly"
            @on-change="
              (checked) => {
                if (checked) {
                  formData.linkChannel = []
                }
              }
            "
          >
            不限
          </Checkbox>
          <CheckboxGroup
            v-model="formData.linkChannel"
            type="button"
            :disabled="readonly"
          >
            <Checkbox label="0" :disabled="readonly" border>Meta</Checkbox>
            <Checkbox label="1" :disabled="readonly" border>TikTok</Checkbox>
            <Checkbox label="2" :disabled="readonly" border>Google</Checkbox>
          </CheckboxGroup>
        </div>
      </Tooltip>
    </FormItem>

    <FormItem
      label="国家范围："
      prop="countriesUnlimited"
      required
      :rules="[
        {
          message: '请选择国家范围',
          trigger: 'change',
          validator(rule, value, callback) {
            if (
              formData.countriesUnlimited !== 0 &&
              formData.countriesUnlimited !== 1
            ) {
              callback('请选择国家范围')
            } else {
              callback()
            }
          }
        }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <RadioGroup
          v-model="formData.countriesUnlimited"
          type="button"
          :disabled="readonly"
          @on-change="formData.countries = []"
          button-style="solid"
        >
          <Radio :label="0" :disabled="readonly">不限</Radio>
          <Radio :label="1" :disabled="readonly">指定国家</Radio>
        </RadioGroup>
      </Tooltip>
    </FormItem>

    <FormItem
      v-if="formData.countriesUnlimited"
      prop="countries"
      :rules="[
        {
          message: '请选择国家',
          trigger: 'change',
          validator(rule, value, callback) {
            if (!formData.countries || formData.countries.length === 0) {
              callback('请选择国家')
            } else {
              callback()
            }
          }
        }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <MultiCascader
          :disabled="readonly"
          style="width: 300px"
          :data="countryLi"
          v-model="formData.countries"
        />
      </Tooltip>
    </FormItem>

    <FormItem
      label="注册剧目："
      prop="playIdsUnlimited"
      :rules="[
        {
          required: true,
          message: '请选择注册剧目',
          trigger: 'change',
          validator(rule, value, callback) {
            if (
              formData.playIdsUnlimited !== 0 &&
              formData.playIdsUnlimited !== 1
            ) {
              callback('请选择注册剧目')
            } else {
              callback()
            }
          }
        }
      ]"
    >
      <Tooltip :disabled="!readonly" :content="`如需修改,请先点击'返回上一步'`">
        <RadioGroup
          v-model="formData.playIdsUnlimited"
          type="button"
          button-style="solid"
          :disabled="readonly"
          @on-change="
            () => {
              formData.playIds = []
              handleGetPlayBatch()
            }
          "
        >
          <Radio :label="0" :disabled="readonly">不限</Radio>
          <Radio :label="1" :disabled="readonly">指定项目</Radio>
        </RadioGroup>
      </Tooltip>
    </FormItem>

    <FormItem
      v-if="formData.playIdsUnlimited"
      prop="playIds"
      :rules="[
        {
          message: '请选择注册剧目',
          trigger: 'change',
          validator(rule, value, callback) {
            if (!formData.playIds || formData.playIds.length === 0) {
              callback('请选择注册剧目')
            } else {
              callback()
            }
          }
        }
      ]"
    >
      <playCascader
        :disabled="readonly"
        style="width: 300px"
        :value="formData.playIds"
        @update:value="formData.playIds = $event"
        ref="playCnRef"
      />
    </FormItem>
  </div>
</template>

<script>
import MultiCascader from '@/components/MultiCascader'
import { getDictionaryList } from '@/api/dictionary'
import { getPlayBatch } from '@/api/play'
import playCascader from '../../launch/play/components/playCascader.vue'

export default {
  name: 'LegacyExperimentTargetFields',
  components: {
    MultiCascader,
    playCascader
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({
        groups: []
      })
    }
  },
  data() {
    return {
      countryLi: []
    }
  },
  methods: {
    handleGetPlayBatch() {
      if (!this.formData.playIds || !this.formData.playIds.length) return

      getPlayBatch({
        ids: this.formData.playIds.join(',')
      }).then((response) => {
        response.data.forEach((item) => {
          this.$refs.playCnRef.$refs.selectRef.onOptionClick({
            label: item.playName,
            value: item.id
          })
        })
      })
    },
    async handleGetCountry() {
      const { data } = await getDictionaryList({
        dictTopic: 'GOODS_COUNTRY_GROUP'
      })

      this.countryLi = (data.records || []).map((item) => ({
        label: item.dictName,
        value: item.dictName,
        children: item.dictValue.split(',').map((child) => ({
          value: child.split('|')[0],
          label: child.split('|')[1]
        }))
      }))
    }
  },
  created() {
    this.handleGetCountry()
  },
  mounted() {
    this.$nextTick(() => {
      if (this.formData.playIdsUnlimited) {
        this.handleGetPlayBatch()
      }
    })
  }
}
</script>
